import React, { useState } from 'react'
import { Form } from 'react-bootstrap'

const ColorPicker = ({ options, onUpdate, checkedOption }) => {
  const [radio, setRadio] = useState(checkedOption || options[0])

  const handleChange = (e) => {
    const name = e.target.name
    const value = e.target.name

    onUpdate(name)
    setRadio(value)
  }

  return (
    <div className='mb-3'>
      {options.map((color, index) => {
        return (
          <Form.Check
            key={index}
            inline
            label={color}
            name={color}
            value={color}
            type={'radio'}
            checked={radio === color}
            id={`inline-${index}-1`}
            onChange={handleChange}
          />
        )
      })}
    </div>
  )
}

export default ColorPicker
